module.exports = __webpack_public_path__ + "static/img/98028D_2_3_R_20181128_LC.f1f31cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/98028D_2_3_R_20181128_LC.png
// module id = Iayx
// module chunks = 0